<template>
  <el-container class="login-container">
    <el-header><h2 class="title">注册</h2></el-header>
    <el-main>
      <el-form label-position="right" :model="addForm" label-width="110px" :rules="addFormRules" ref="addForm">
        <el-row :gutter="20">
          <el-col :span="10">
            <el-form-item label="用户名" prop="user.userName" class="clear-margin-bottom">
              <el-input v-model="addForm.user.userName" auto-complete="off" @keyup.native="check_zh"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="真实姓名" prop="user.realName" class="clear-margin-bottom">
              <el-input v-model="addForm.user.realName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="昵称" prop="user.nickName" class="clear-margin-bottom">
              <el-input v-model="addForm.user.nickName" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="密码" prop="user.password" class="clear-margin-bottom">
              <el-input v-model="addForm.user.password" auto-complete="off" type="password"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="确认密码" prop="user.confirmPassword" class="clear-margin-bottom">
              <el-input v-model="addForm.user.confirmPassword" auto-complete="off" type="password"> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件类型" prop="user.certType" class="clear-margin-bottom">
              <el-select v-model="addForm.user.certType" clearable placeholder="请选择">
                <el-option v-for="item in dictCertType" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="证件号码" prop="user.certNo" class="clear-margin-bottom">
              <el-input v-model="addForm.user.certNo" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="手机号" prop="user.mobile" class="clear-margin-bottom">
              <el-input v-model="addForm.user.mobile" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="邮箱" prop="user.email" class="clear-margin-bottom">
              <el-input type="email" v-model="addForm.user.email" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="性别" prop="user.sex" class="clear-margin-bottom">
              <el-select v-model="addForm.user.sex" clearable placeholder="请选择">
                <el-option v-for="item in dictSex" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="市级区县" prop="org.level" class="clear-margin-bottom">
              <el-select v-model="addForm.org.level1" clearable placeholder="请选择" @change="selectcode1">
                <el-option v-for="item in items1" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>
              <el-select v-model="addForm.org.level2" clearable placeholder="请选择" @change="selectcode2" style="margin-left: 10px;">
                <el-option v-for="item in items2" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>
              <el-select v-model="addForm.org.level3" clearable placeholder="请选择" @change="selectcode3" style="margin-left: 10px;">
                <el-option v-for="item in items3" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select> 
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="机构名称" prop="org.name">
              <el-input v-model="addForm.org.name" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构类型" prop="org.type" class="clear-margin-bottom">
              <el-select v-model="addForm.org.type" clearable placeholder="请选择">
                <el-option v-for="item in dictOrgType" :key="item.value" :label="item.name" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="责任人" prop="detail.leader" >
              <el-input v-model="addForm.detail.leader" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="联系人姓名" prop="detail.contact">
              <el-input v-model="addForm.detail.contact" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="联系人手机号" prop="detail.mobile">
              <el-input v-model="addForm.detail.mobile" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="机构地址" prop="detail.address">
              <el-input v-model="addForm.detail.address" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="场所建筑面积" prop="detail.xiaoFangArea">
              <el-input v-model.number="addForm.detail.xiaoFangArea" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="使用层数" prop="detail.xiaoFangUseNumber" >
              <el-input v-model.number="addForm.detail.xiaoFangUseNumber" auto-complete="off" placeholder="地上、地下"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="建筑结构" prop="detail.xiaoFangBuildingStructure">
              <el-input v-model="addForm.detail.xiaoFangBuildingStructure" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <label class="el-form-item__label">消防验收/备案情况</label>
          </el-col>
          <el-col :span="21">
            <el-row>
              <el-col :span="8">
                <el-form-item label-width="155px" label="是否依法通过消防验收" prop="detail.xiaoFangYanShou" style="text-align:left;">
                  <el-radio v-model="addForm.detail.xiaoFangYanShou" :label="1">是</el-radio>
                  <el-radio v-model="addForm.detail.xiaoFangYanShou" :label="0">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-if="addForm.detail.xiaoFangYanShou == '1'" label-width="50px" label="文号" prop="detail.xiaoFangYanShouWenHao">
                  <el-input v-model="addForm.detail.xiaoFangYanShouWenHao" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="9">
                <el-form-item label-width="210px" label="是否依法进行竣工验收消防备案" prop="detail.xiaoFangBeiAn" >
                  <el-radio v-model="addForm.detail.xiaoFangBeiAn" :label="1">是</el-radio>
                  <el-radio v-model="addForm.detail.xiaoFangBeiAn" :label="0">否</el-radio>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item v-if="addForm.detail.xiaoFangBeiAn == '1'" label-width="50px" label="文号" prop="detail.xiaoFangBeiAnWenHao">
                  <el-input v-model="addForm.detail.xiaoFangBeiAnWenHao" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <!--
            <el-row>
              <el-col :span="17">
                <el-form-item label-width="70px" label="其他情况" prop="detail.xiaoFangOthers">
                  <el-input v-model="addForm.detail.xiaoFangOthers" auto-complete="off"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            -->
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="420px" label="建筑总平面布局、防火间距、消防车通道等是否符合消防技术标准" prop="detail.xiaoFangJiShu">
              <el-radio v-model="addForm.detail.xiaoFangJiShu" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangJiShu" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="167px" label="是否违规采用彩钢板搭建" prop="detail.xiaoFangCaiGang">
              <el-radio v-model="addForm.detail.xiaoFangCaiGang" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangCaiGang" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="237px" label="是否违规使用可燃易燃材料装修装饰" prop="detail.xiaoFangKeRanYiRan">
              <el-radio v-model="addForm.detail.xiaoFangKeRanYiRan" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangKeRanYiRan" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="196px" label="是否违规存放易燃易爆危险品" prop="detail.xiaoFangYiRanYiBao">
              <el-radio v-model="addForm.detail.xiaoFangYiRanYiBao" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangYiRanYiBao" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="114px" label="防火分隔不到位" prop="detail.xiaoFangFangHuoFenGe">
              <el-radio v-model="addForm.detail.xiaoFangFangHuoFenGe" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangFangHuoFenGe" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="212px" label="电器线路是否采取防火保护措施" prop="detail.xiaoFangFangHuoBaoHu">
              <el-radio v-model="addForm.detail.xiaoFangFangHuoBaoHu" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangFangHuoBaoHu" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="130px" label="消防设施损坏停用" prop="detail.xiaoFangSheShiSunHuai">
              <el-radio v-model="addForm.detail.xiaoFangSheShiSunHuai" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangSheShiSunHuai" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="299px" label="建筑消防设施设置是否符合消防技术标准要求" prop="detail.xiaoFangFuHeJiShu">
              <el-radio v-model="addForm.detail.xiaoFangFuHeJiShu" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangFuHeJiShu" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="20">
            <el-form-item label-width="188px" label="本单位主要的消防设施有：" prop="detail.xiaoFangSheShi">
              <el-checkbox-group v-model="addForm.detail.xiaoFangSheShi" >
                <el-checkbox v-for="sheshi in sheshis" :label="sheshi.value" :key="sheshi.value">{{sheshi.name}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label-width="218px" label="消防设施器材是否保持完好有效" prop="detail.xiaoFangSheShiYouXiao">
              <el-radio v-model="addForm.detail.xiaoFangSheShiYouXiao" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangSheShiYouXiao" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="13">
            <el-form-item v-if="addForm.detail.xiaoFangSheShiYouXiao == '0'" label-width="136px" label="有故障的消防设施" prop="detail.xiaoFangGuZhangSheShi">
              <el-input v-model="addForm.detail.xiaoFangGuZhangSheShi" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="206px" label="电动自行车是否违规停放充电" prop="detail.xiaoFangZiXingChe">
              <el-radio v-model="addForm.detail.xiaoFangZiXingChe" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangZiXingChe" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="136px" label="是否违规动火用电" prop="detail.xiaoFangHuoDian">
              <el-radio v-model="addForm.detail.xiaoFangHuoDian" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangHuoDian" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="360px" label="是否签订维保合同，并按规定对消防设施进行维修保养" prop="detail.xiaoFangWeiBaoHeTong">
              <el-radio v-model="addForm.detail.xiaoFangWeiBaoHeTong" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangWeiBaoHeTong" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="472px" label="消防设施器材是否设置规范醒目的标识，用文字或图例标明操作使用方法" prop="detail.xiaoFangSheZhiXingMuBiaoShi">
              <el-radio v-model="addForm.detail.xiaoFangSheZhiXingMuBiaoShi" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangSheZhiXingMuBiaoShi" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="342px" label="是否存在占用、堵塞、锁闭疏散通道和安全出口行为" prop="detail.xiaoFangAnQuanChuKou">
              <el-radio v-model="addForm.detail.xiaoFangAnQuanChuKou" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangAnQuanChuKou" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="370px" label="是否在门窗上设置影响逃生和灭火救援的铁柵栏、障碍物" prop="detail.xiaoFangZhangAiWu">
              <el-radio v-model="addForm.detail.xiaoFangZhangAiWu" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangZhangAiWu" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="384px" label="是否落实消防安全主体责任，确定消防安全责任人、管理人" prop="detail.xiaoFangLuoShi">
              <el-radio v-model="addForm.detail.xiaoFangLuoShi" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangLuoShi" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="314px" label="是否制定落实消防安全制度并面向全体员工公布" prop="detail.xiaoFangLuoShiYuanGong">
              <el-radio v-model="addForm.detail.xiaoFangLuoShiYuanGong" :label="0">已制定</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangLuoShiYuanGong" :label="1">已制定但内容不全</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangLuoShiYuanGong" :label="2">未制定</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangLuoShiYuanGong" :label="3">未公布</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="258px" label="是否制定符合消防安全要求的操作规程" prop="detail.xiaoFangAnQuanGuiFan">
              <el-radio v-model="addForm.detail.xiaoFangAnQuanGuiFan" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangAnQuanGuiFan" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label-width="314px" label="是否制定灭火和应急疏散预案，并组织消防演练" prop="detail.xiaoFangYanXi">
              <el-radio v-model="addForm.detail.xiaoFangYanXi" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangYanXi" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item v-if="addForm.detail.xiaoFangYanXi == '1'" label-width="120px" label="消防演练次数" prop="detail.xiaoFangYanXiCiShu">
              <el-input v-model.number="addForm.detail.xiaoFangYanXiCiShu" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="412px" label="是否按排查整治标准定期进行防火检查、巡查，并填写检查记录" prop="detail.xiaoFangJianCha">
              <el-radio v-model="addForm.detail.xiaoFangJianCha" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangJianCha" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label-width="315px" label="是否组织员工进行岗前和定期消防安全教育培训" prop="detail.xiaoFangPeiXun">
              <el-radio v-model="addForm.detail.xiaoFangPeiXun" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangPeiXun" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item v-if="addForm.detail.xiaoFangPeiXun == '1'" label-width="120px" label="已培训员工数" prop="detail.xiaoFangPeiXunRenShu">
              <el-input v-model.number="addForm.detail.xiaoFangPeiXunRenShu" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-form-item label-width="315px" label="消防控制室值班人员是否经过培训，并持证上岗" prop="detail.xiaoFangChiZheng">
              <el-radio v-model="addForm.detail.xiaoFangChiZheng" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangChiZheng" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item v-if="addForm.detail.xiaoFangChiZheng == '1'" label-width="120px" label="持证上岗人数" prop="detail.xiaoFangChiZhengRenShu">
              <el-input v-model.number="addForm.detail.xiaoFangChiZhengRenShu" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label-width="217px" label="员工是否掌握岗位消防安全知识" prop="detail.xiaoFangAnQuanZhiShi">
              <el-radio v-model="addForm.detail.xiaoFangAnQuanZhiShi" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangAnQuanZhiShi" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="9">
            <el-form-item label-width="260px" label="单位是否建立专职消防队或志愿消防队" prop="detail.xiaoFangXiaoFangDui">
              <el-radio v-model="addForm.detail.xiaoFangXiaoFangDui" :label="1">是</el-radio>
              <el-radio v-model="addForm.detail.xiaoFangXiaoFangDui" :label="0">否</el-radio>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item v-if="addForm.detail.xiaoFangXiaoFangDui == '1'" label-width="136px" label="专职消防队人数" prop="detail.xiaoFangXiaoFangDuiRenShu">
              <el-input v-model.number="addForm.detail.xiaoFangXiaoFangDuiRenShu" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item v-if="addForm.detail.xiaoFangXiaoFangDui == '1'" label-width="160px" label="志愿消防队人数" prop="detail.xiaoFangZhiYuanXiaoFangDuiRenShu">
              <el-input v-model.number="addForm.detail.xiaoFangZhiYuanXiaoFangDuiRenShu" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label-width="76px" label="其他情况" prop="detail.xiaoFangRemarks">
              <el-input v-model="addForm.detail.xiaoFangRemarks" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item prop="user.sidentify" label-width="64px" label="验证码"> 
              <el-input placeholder="验证码" v-model="addForm.user.sidentify" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <img :src='url1' @click="chang_url"/> 
          </el-col>
        </el-row>
        <el-form-item style="width:100%;text-align:center;">
          <el-button type="primary" style="width:40%;" @click.native.prevent="handleAgree" :loading="loading">注册</el-button>
          <el-button type="warning" style="width:40%;" @click.native.prevent="handleDisAgree">后退   </el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
  import API from "../api/api_user";
  import LOGIN_API from "../api/api_login";
  import DICT_API from "../api/api_dict";

  export default {
    data() {
    //自定义下拉框校验函数
    const isSelect = (rule, value, callback) => {
      // console.log(value);
      if (value =='') { 
        return callback(new Error("请选择"));
      } else {
        callback();
      }
    };
      return {
        url1:"/api/defaultKaptcha",
         //新增相关数据
        addLoading: false,
        addFormRules: {
          'user.userName': [
            {required: true, message: "请输入用户名",trigger: "blur"},
            {
              required: true,
              pattern: /^[a-zA-Z0-9_-]{4,16}$/,
              message: '用户名为4到16位字符，只能为字母，数字，下划线，减号',
              trigger: 'blur'
            }
          ],
          'user.password': [
            {
              required: true,
              message: "请输入密码",
              trigger: "blur"
            }
          ],
          'user.confirmPassword': [
            {
              required: true,
              message: "请输入确认密码",
              trigger: "blur"
            }
          ],
          'user.realName': [
            {
              required: true,
              message: "请输入真实姓名", 
              trigger: "blur"
            }
          ],
          
          //'org.level': [{required: true, message: "请选择区县", trigger: "change", validator: isSelect }],
          'org.name': [
            {
              required: true,
              message: "请输入机构名称", 
              trigger: "blur"
            }
          ],
          'org.type': [
            {
              required: true, 
              message: "请输入机构类型", 
              trigger: "blur"
            }
          ],
          'detail.contact': [
            {
              required: true, 
              message: "请输入联系人", 
              trigger: "blur"
            }
          ],
          'detail.mobile': [
            {
              required: true, 
              message: "请输入联系电话", 
              trigger: "blur"
            }
          ],

          "detail.xiaoFangArea":[
            { 
              required: true, 
              message: '请输入建筑面积', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '建筑面积必须为数字值', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangUseNumber":[
            { 
              required: true, 
              message: '请输入层数', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '层数必须为数字值', 
              trigger: 'blur' }
          ],
          "detail.xiaoFangYanShouWenHao": [
            { 
              required: true, 
              message: '请输入文号', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangBeiAnWenHao": [
            { 
              required: true, 
              message: '请输入文号', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangGuZhangSheShi": [
            { 
              required: true, 
              message: '请输入有故障的消防设施', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangYanXiCiShu":[
            { 
              required: true, 
              message: '请输入演习次数', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '演习次数必须为数字值', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangPeiXunRenShu":[
            { 
              required: true, 
              message: '请输入培训人数', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '培训人数必须为数字值', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangXiaoFangDuiRenShu":[
            { 
              required: true, 
              message: '请输入专职消防队人数', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '专职消防队人数必须为数字值', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangZhiYuanXiaoFangDuiRenShu":[
            { 
              required: true, 
              message: '请输入志愿消防队人数', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '志愿消防队人数必须为数字值', 
              trigger: 'blur' 
            }
          ],
          "detail.xiaoFangChiZhengRenShu":[
            { 
              required: true, 
              message: '请输入持证人数', 
              trigger: 'blur' 
            },
            { 
              type: 'number', 
              message: '持证人数必须为数字值', 
              trigger: 'blur' 
            }
          ]
        },
        addForm: {
          user:{},
          org:{},
          detail:{
            xiaoFangSheShi:[],
            xiaoFangYanShou: 0,
            xiaoFangBeiAn: 0,
            xiaoFangJiShu: 0,
            xiaoFangCaiGang: 0,
            xiaoFangKeRanYiRan: 0,
            xiaoFangYiRanYiBao: 0,
            xiaoFangFangHuoFenGe: 0,
            xiaoFangFangHuoBaoHu: 0,
            xiaoFangSheShiSunHuai: 0,
            xiaoFangFuHeJiShu: 0,
            xiaoFangSheShiYouXiao: 0,
            xiaoFangZiXingChe: 0,
            xiaoFangHuoDian: 0,
            xiaoFangWeiBaoHeTong: 0,
            xiaoFangSheZhiXingMuBiaoShi: 0,
            xiaoFangAnQuanChuKou: 0,
            xiaoFangZhangAiWu: 0,
            xiaoFangLuoShi: 0,
            xiaoFangLuoShiYuanGong: 3,
            xiaoFangAnQuanGuiFan: 0,
            xiaoFangYanXi: 0,
            xiaoFangJianCha: 0,
            xiaoFangPeiXun: 0,
            xiaoFangChiZheng: 0,
            xiaoFangAnQuanZhiShi: 0,
            xiaoFangXiaoFangDui: 0
          }
        },

        items1:[],
        items2:[],
        items3:[],
        sheshis :[
          {
            name:"消火栓系统",
            value:"0"
          },
          {
            name:"火灾自动报警系统",
            value:"1"
          },
          {
            name:"防排烟系统",
            value:"2"
          },
          {
            name:"自动喷水灭火系统",
            value:"3"
          },
          {
            name:"气体灭火系统",
            value:"4"
          },
          {
            name:"灭火器",
            value:"5"
          },
          {
            name:"应急照明灯",
            value:"6"
          },
          {
            name:"疏散指示标志",
            value:"7"
          },
          {
            name:"防火卷帘",
            value:"8"
          },
          {
            name:"其他系统",
            value:"9"
          },
        ],  

        dictSex: [],
        dictCertType: [],
        dictOrgType: [],
        loading: false,
        dictAgreeTypes: [],
        checkedAgreeTypes:[],
        orgid:"",
        organization:{
          name:""
        }
      };
    },
    mounted: function () {//页面初始化方法
        let params="";
        let that = this;
        DICT_API.dictSex(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
                that.dictSex = result.data;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

        DICT_API.dictOrgType(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.dictOrgType = [];
              result.data.forEach(item => {
                if(item.value!="00"){
                  that.dictOrgType.push(item);
                }
              });
            }
          }, 
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        ).catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

        DICT_API.dictCertType(params)
        .then(
          function(result){
            if (result && result.code == 200) {
              that.dictCertType = result.data;
            }
          }, 
          function (error){
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error){
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });

        LOGIN_API.orgTypeAndCode_list(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.items1 = result.data.orgTypeAndCode;
            }
          },
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        ).catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
    },
    watch: {
      'addForm.org.level1': function (newValue, oldValue) {
        this.items1.forEach(item => {
          if(newValue==item.code){
            // console.log(item.id); 
            this.addForm.org.parentId=item.id 
          }
        });
        if(oldValue==undefined||newValue==oldValue){

            
        }else{
          this.addForm.org.level2 = null;
          this.addForm.org.level3 = null;
          this.items2=[];
          this.items3=[];
        }
          
      },
      'addForm.org.level2': function (newValue, oldValue) {
               
        this.items2.forEach(item => {
          if(newValue==item.code){
            // console.log(item.id); 
            this.addForm.org.parentId=item.id 
          }
        });

        if(oldValue==undefined||newValue==oldValue){

        }else{
          this.addForm.org.level3 = null;
          this.items3=[];
        }
          
      },
      'addForm.org.level3': function (newValue, oldValue) {
        this.items3.forEach(item => {
          if(newValue==item.code){
            this.addForm.org.parentId=item.id 
            // console.log(item.id); 

          }
        }); 
      }
    },
    methods: {
       //文本框不能输入中文
      check_zh(){
        let that = this;
        that.addForm.user.userName = that.addForm.user.userName.replace(/[\u4E00-\u9FA5]|[\uFE30-\uFFA0]/g, '');
      },
      chang_url(){
        this.url1="/api/defaultKaptcha?a="+new Date().toString();
      },
      selectcode1(){
        let that = this;
        var code = that.addForm.org.level1;
        // console.log(code);
        let params = {
          code: code,
          level: 2
        };
        LOGIN_API.orgTypeAndCode_list2(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.items2 = result.data.orgTypeAndCode;
            }
          }, 
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      },
      selectcode2(){
        let that = this;
        var code = that.addForm.org.level2;
        let params = {
          code:code,
          level:3
        };
        LOGIN_API.orgTypeAndCode_list2(params)
        .then(
          function (result) {
            if (result && result.code == 200) {
              that.items3 = result.data.orgTypeAndCode;
            }
          }, 
          function (error) {
            that.$message.error({
              showClose: true,
              message: error.toString(),
              duration: 2000
            });
          }
        )
        .catch(function (error) {
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000
          });
        });
      },
      selectcode3(){
        this.$forceUpdate();
      },
      handleCheckedAgreesChange(value){
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.dictAgreeTypes.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.dictAgreeTypes.length;
      },
      handleDisAgree(){
        this.$router.push({path: "/login"});
      },
      handleAgree() {
        let that = this;
        let para = that.addForm;
        // console.log(para.org.level1);

        if(para.org.level1==undefined){
          that.$message.error({
            showClose: true,
            message: "请选择区县",
            duration: 1000
          });
          return;
        }
        if(para.org.level2==undefined){
          that.$message.error({
            showClose: true,
            message: "请选择区县",
            duration: 1000
          });
          return;
        }
        if(para.org.level3==undefined){
          that.$message.error({
            showClose: true,
            message: "请选择区县",
            duration: 1000
          });
          return;
        }

        // console.log(para.detail.xiaoFangSheShi.toString());   
        para.detail.xiaoFangSheShi=para.detail.xiaoFangSheShi.toString(); 
        // console.log(para);   
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            LOGIN_API.reg(para)
            .then(
              function (result) {
                that.addForm.detail.xiaoFangSheShi=[];
                that.loading = false;
                if (result && result.code == 200) {
                  that.$message.success({
                    showClose: true,
                    message: '注册成功',
                    duration: 2000
                  });
                  that.$router.push({path: "/login"});
                } else {
                  that.$message.error({
                    showClose: true,
                    message: "注册失败",
                    duration: 2000
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000
              });
            });
          
          }
        });
      }
    }
  };
</script>
<style>
  body {
    background: #dfe9fb;
  }
</style>
<style lang="scss" scoped>
  .login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 0px auto;
    width: 1200px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;

    background: -ms-linear-gradient(top, #ace, #00c1de); /* IE 10 */
    background: -moz-linear-gradient(top, #ace, #00c1de); /*火狐*/
    background: -webkit-gradient(
        linear,
        0% 0%,
        0% 100%,
        from(#ace),
        to(#00c1de)
    ); /*谷歌*/
    background: -webkit-linear-gradient(
        top,
        #ace,
        #00c1de
    ); /*Safari5.1 Chrome 10+*/
    background: -o-linear-gradient(top, #ace, #00c1de); /*Opera 11.10+*/

    .title {
      margin: 0px auto 40px auto;
      text-align: center;
      color: #505458;
    }

    .remember {
      margin: 0px 0px 35px 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// Reg.vue?0ed2c462